import { render, staticRenderFns } from "./FileQuotas.vue?vue&type=template&id=b048e164&"
import script from "./FileQuotas.vue?vue&type=script&lang=js&"
export * from "./FileQuotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports